import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { ComposePortalMessageComponent } from './component/compose-portal-message/compose-portal-message.component';
import { PortalMessageTemplatePickerComponent } from './component/portal-message-template-picker/portal-message-template-picker.component';
import { ComposeSmsMessageComponent } from './component/compose-sms-message/compose-sms-message.component';
import { SendingChannelIconComponent } from './component/sending-channel-icon/sending-channel-icon.component';
import { ComposeEmailMessageComponent } from './component/compose-email-message/compose-email-message.component';
import { ClaimThreadsListComponent } from './component/claim-threads-list/claim-threads-list.component';
import { PortalMessageThreadFormComponent } from './component/portal-message-thread-form/portal-message-thread-form.component';
import { PortalMessageThreadManageComponent } from './component/portal-message-thread-manage/portal-message-thread-manage.component';
import { ThreadMessagesComponent } from './component/thread-messages/thread-messages.component';
import { RepairThreadButtonComponent } from './component/repair-thread-button/repair-thread-button.component';
import { PortalUsersModule } from '../portal-users/portal-users.module';
import { UserPortalMessagesIndicatorComponent } from './component/user-portal-messages-indicator/user-portal-messages-indicator.component';
import { UserPortalMessagesListComponent } from './component/user-portal-messages-list/user-portal-messages-list.component';
import { MessageItemComponent } from './component/message-item/message-item.component';
import { UserPortalSentMessagesListComponent } from './component/user-portal-sent-messages-list/user-portal-sent-messages-list.component';
import { UserPortalReceivedMessagesListComponent } from './component/user-portal-received-messages-list/user-portal-received-messages-list.component';
import { DocumentsModule } from '../documents/documents.module';

const sharedComponents = 
[
  ComposePortalMessageComponent,
  PortalMessageTemplatePickerComponent,
  ComposeSmsMessageComponent,
  SendingChannelIconComponent,
  ComposeEmailMessageComponent,
  ClaimThreadsListComponent,
  PortalMessageThreadFormComponent,
  PortalMessageThreadManageComponent,
  ThreadMessagesComponent,
  RepairThreadButtonComponent,
  UserPortalMessagesIndicatorComponent,
  UserPortalMessagesListComponent,
  MessageItemComponent,
  UserPortalSentMessagesListComponent,
  UserPortalReceivedMessagesListComponent,
]

@NgModule({
  declarations: [
    sharedComponents,
    
  ],
  imports: [
    SharedModule,
    PortalUsersModule,
    DocumentsModule
  ],
  exports: [
    sharedComponents
  ]
})
export class PortalMessageModule { }
